import CheckApplication from './check-application';

export default CheckApplication;

export {
    CheckApplication,
};
